export default __webpack_public_path__ + "static/media/Drop-in-a-mail-@servicedesk@4iapps.com.f5f49c1a.png";